import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'designing-smart-layout-options',
  styleUrls: ['../designing.component.scss'],
  templateUrl: './smartLayoutOptions.component.html',
})
export class DesigningSmartLayoutOptionsComponent {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(public translate: TranslateService) {}

  submit() {
    this.next.emit();
  }
}
